export { ScrollArea } from './ScrollArea'
export type { ScrollAreaProps } from './ScrollArea'
